import { RemixiconComponentType } from '@remixicon/react';

import { AgButton, AgText } from 'src/components/ui';

export type SettingsCardProps = { title: string; description: string; icon: RemixiconComponentType; route: string };

export default function SettingsCard(props: SettingsCardProps) {
  const Icon = props.icon;
  return (
    <div className="flex h-full flex-col items-start gap-4 rounded-lg border border-neutral-5 bg-white p-5">
      <div className="flex items-center justify-center rounded-lg bg-brand-1 p-2">
        <Icon size={24} className="text-brand-text" />
      </div>
      <div className="grow" />
      <AgText size="16" weight="semibold">
        {props.title}
      </AgText>
      <AgText size="14" color="secondary" className="-mt-2">
        {props.description}
      </AgText>
      <AgButton variant="white" href={props.route} shape="rounded">
        View
      </AgButton>
    </div>
  );
}
